<mat-form-field appearance="outline" >
  <mat-label>Labs</mat-label>
  <mat-select multiple [(value)]="searchParams.labs">
    <mat-option *ngIf="labs.length===0" disabled>
      <mat-spinner class="example-margin" color="primary" mode="indeterminate" [diameter]="25"> </mat-spinner>
    </mat-option>
    <mat-checkbox class="mat-option"
                  [disableRipple]="true"
                  [indeterminate]="isIndeterminate()"
                  [checked]="isChecked()"
                  (click)="$event.stopPropagation()"
                  (change)="toggleSelection($event)"
                  *ngIf="labs.length>0">

      Select All
    </mat-checkbox>

    <mat-option *ngFor="let lab of labs" [value]="lab.LAB_SN">
      <img [src]="'data:image/png;base64,'+lab.LAB_IMAGE" height="25px">
      {{lab.LAB_FN}}
    </mat-option>
  </mat-select>
</mat-form-field>




<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Agency</mat-label>
  <input type="text"
         placeholder="Pick one"
         aria-label="Number"
         matInput
         [matAutocomplete]="auto"
         [formControl]="AgencyListControl"
         [(ngModel)]="searchParams.agency">
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let option of filteredAgenyList| async" [value]="option.DeptName">
      {{option.DeptName}}
    </mat-option>
  </mat-autocomplete>
  <!--<input matInput [(ngModel)]="searchParams.agency" name="NAGENCY">-->
</mat-form-field>

<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Reference/HIT #</mat-label>
  <input matInput [(ngModel)]="searchParams.referencenumber" name="NREF">
</mat-form-field>

<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Lab #</mat-label>
  <input matInput [(ngModel)]="searchParams.labnumber" name="NLAB">
</mat-form-field>

<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Case #</mat-label>
  <input matInput [(ngModel)]="searchParams.casenumber" name="NCASE">
</mat-form-field>

<mat-form-field appearance="outline" style="padding-left: 3px;">
  <mat-label>From Date</mat-label>
  <input matInput appFormatDateInput [matDatepicker]="FromDate"  [(ngModel)]="searchParams.fromdate" name="FDATE">
  <mat-datepicker-toggle matSuffix [for]="FromDate"></mat-datepicker-toggle>
  <mat-datepicker #FromDate></mat-datepicker>
</mat-form-field>

  <mat-form-field appearance="outline" style="padding-left: 3px;">
    <mat-label>To Date</mat-label>
    <input matInput appFormatDateInput [matDatepicker]="ToDate"  [(ngModel)]="searchParams.todate" name="TDATE">
    <mat-datepicker-toggle matSuffix [for]="ToDate"></mat-datepicker-toggle>
    <mat-datepicker #ToDate></mat-datepicker>
  </mat-form-field>

<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Weapon Serial</mat-label>
  <input matInput [(ngModel)]="searchParams.weapon_serial" name="WSERIAL">
</mat-form-field>


<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Person Firstname</mat-label>
  <input matInput [(ngModel)]="searchParams.person_firstname" name="PFNAME">
</mat-form-field>

<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Person Lastname</mat-label>
  <input matInput [(ngModel)]="searchParams.person_lastname" name="PLNAME">
</mat-form-field>

<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Person SBI</mat-label>
  <input matInput [(ngModel)]="searchParams.person_sbi" name="PSBI">
</mat-form-field>

<mat-form-field appearance="outline"  style="padding-left: 3px;">
  <mat-label>Person FBI</mat-label>
  <input matInput [(ngModel)]="searchParams.person_fbi" name="PFBI">
</mat-form-field>




<button mat-stroked-button (click)="submitSearch()" style="margin-left: 3px;"><mat-icon>search</mat-icon>&nbsp;Search</button>
<button mat-stroked-button (click)="resetSearchParams()" style="margin-left: 3px;"><mat-icon>replay</mat-icon>&nbsp;Clear</button>
<button mat-stroked-button  (click)="reload()" style="margin-left: 3px;"><mat-icon>restart_alt</mat-icon>&nbsp;Refresh</button>
